var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3984 3.14778H11.1912V2.36024C11.1912 1.92596 10.8328 1.5735 10.3912 1.5735H2.4C1.9584 1.5735 1.6 1.92596 1.6 2.36024V17.2133C1.6 17.6475 1.2416 18 0.8 18C0.3584 18 0 17.6475 0 17.2133V2.36024C0 1.0566 1.0744 0 2.4 0H10.3912C11.7168 0 12.7912 1.0566 12.7912 2.36024V3.14778H13.6C14.9256 3.14778 16 4.20438 16 5.50802V12.4684C16 13.772 14.9256 14.8286 13.6 14.8286H12.7912V16.93C12.7912 17.3643 12.4328 17.7168 11.9912 17.7168C11.5496 17.7168 11.1912 17.3643 11.1912 16.93V14.8286H10.3984C9.0728 14.8286 7.9984 13.772 7.9984 12.4684V5.50802C7.9984 4.20438 9.0728 3.14778 10.3984 3.14778ZM9.536 12.4361C9.536 12.8704 9.8944 13.2229 10.336 13.2229H13.5376C13.9792 13.2229 14.3376 12.8704 14.3376 12.4361V5.47576C14.3376 5.04148 13.9792 4.68902 13.5376 4.68902H10.336C9.8944 4.68902 9.536 5.04148 9.536 5.47576V6.25464L11.1408 6.26172C11.5824 6.2633 11.9392 6.61812 11.9376 7.05162C11.936 7.4859 11.5752 7.83679 11.1344 7.83522L9.536 7.82814V9.38039L11.1408 9.38747C11.5824 9.38983 11.9392 9.74387 11.9376 10.1782C11.936 10.6124 11.5752 10.9633 11.1344 10.961L9.536 10.9539V12.4361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfusion);
export default __webpack_public_path__ + "static/media/infusion.5972ab8aef980dcdb27d70911f42f2e2.svg";
export { ForwardRef as ReactComponent };